import React from "react";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class TableProfitCalculator extends React.Component {

    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }

    calculate(valuesArray) {
        // console.log(valuesArray)
        let Invoice = 0
        let Refund = 0
        let Order = 0

        if (valuesArray) {
            // console.log(valuesArray)
            valuesArray.forEach(values => {

                let total = 0
                let disountRate = 0
                let taxRate = 0
                let totalNeedTax = 0
                let totalNeedDiscount = 0
                let discount = 0
                let tax = 0
                let subTotal

                if (values.list) {
                    for (let i = 0; i < values.list.length; i++) {
                        const value = values.list[i];
                        // console.log(value)
                        if (!value.tax && !value.discount) {
                            total = total + Number(value.amount)
                            if (!value.taxFree) {
                                totalNeedTax = totalNeedTax + Number(value.amount)
                            }
                            if (!value.discountFree) {
                                totalNeedDiscount = totalNeedDiscount + Number(value.amount)
                            }
                        }
                        if (value.tax) {
                            if (typeof value.amount == "string") {
                                taxRate = Number(value.amount.replace('%', '')) / 100
                            } else {
                                taxRate = Number(value.amount) / 100
                            }
                        }
                        if (value.discount) {
                            if (typeof value.amount == "string") {
                                disountRate = Number(value.amount.replace('%', '')) / 100
                            } else {
                                disountRate = Number(value.amount) / 100
                            }
                        }
                    }

                    subTotal = Number(total)
                    discount = (totalNeedDiscount * disountRate)
                    tax = ((totalNeedTax - discount) * taxRate)

                    total = Number(total - discount + tax)
                    // console.log(total)
                    switch (values.type) {
                        case 'Invoice':
                            Invoice = Invoice + total
                            break;
                        case 'Order':
                            Order = Order + total
                            break;

                        case 'Refund':
                            Refund = Refund + total
                            break;
                        default:
                            break;
                    }
                    // [values.values.type] = [values.values.type]+total
                }
            });

            // total=total*0.
            // console.log(Invoice)
            // let total = Invoice-Order-Refund
            let Profit = Invoice-Order-Refund

            return { Invoice, Order, Refund,Profit }
        }

    }

    render() {
        return (
            <div className='text-center '>

                <p className="" >{this.props.data ? this.calculate(this.props.data)[this.props.header.information.showKey].toFixed(2) : 0}</p>

            </div>
        );
    }
}

export default TableProfitCalculator;
